import { MenuIcon, MultiSelect, PriceBandIcon } from '@weareopenr/component-library';
import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { IMenu } from 'src/types/menu.types';

type PriceSchemeFiltersProps = {
  menus: IMenu[];
  searchMenus: string[];
  setSearchMenus: (menus: string[]) => void;
  hasPricingCategoryFilterFeature: boolean;
  searchPricingCategories?: string[];
  pricingCategoryOptions?: SelectedMultiOption[];
  setSearchPricingCategories?: (categories: string[]) => void;
};

export const PriceSchemeFilters = ({
  menus,
  searchMenus,
  setSearchMenus,
  hasPricingCategoryFilterFeature,
  pricingCategoryOptions,
  searchPricingCategories,
  setSearchPricingCategories,
}: PriceSchemeFiltersProps) => (
  <>
    {menus?.length > 0 && (
      <MultiSelect
        Icon={MenuIcon}
        label="Menus"
        options={menus?.map((menu, index) => ({ id: menu.menuId, label: menu.name, display_order: index })) || []}
        selected={searchMenus}
        onChange={setSearchMenus}
        disabled={menus?.length === 0}
      />
    )}
    {hasPricingCategoryFilterFeature && pricingCategoryOptions.length > 0 && (
      <MultiSelect
        Icon={PriceBandIcon}
        label="Pricing Categories"
        options={pricingCategoryOptions}
        selected={searchPricingCategories}
        onChange={setSearchPricingCategories}
      />
    )}
  </>
);
